import { IEvent, IHost } from "@Interfaces";
import { INDIA, isIndia } from "@Utils";

export const getAreIntlPaymentsEnabled = ({
    host,
    eventData,
}: {
    host: IHost.IStore;
    eventData?: IEvent.IEventData;
}): boolean =>
    !!(
        !isIndia(host?.country?.name || INDIA) &&
        eventData?.is_international_enabled
    );
